import { queryOptions } from '@tanstack/react-query';
import {
  api,
  type WorkloadQuery,
  type WorkloadContributionsQuery,
} from '@/api/api';

export const workloadKeys = {
  all: ['workload'] as const,
  range: (query: WorkloadQuery) => [...workloadKeys.all, query] as const,
  contributions: (query: WorkloadContributionsQuery) =>
    [...workloadKeys.all, 'contributions', query] as const,
};

export const workloadOptions = (query: WorkloadQuery) =>
  queryOptions({
    queryKey: workloadKeys.range(query),
    queryFn: () => api.getWorkload(query),
  });

export const contributionsOptions = (query: WorkloadContributionsQuery) =>
  queryOptions({
    queryKey: workloadKeys.contributions(query),
    queryFn: () => api.getWorkloadContributions(query),
  });
